/* src/app/ui/topbar/topbar.component.scss */
.topbar-wrapper {
  padding: 1.75rem;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  width: 100%;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.topbar-wrapper > .input-group > .input-group-append {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
}
.topbar-wrapper > .user-group {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  width: auto;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.badge {
  display: block;
  position: absolute;
  height: 0.5rem;
  width: 0.5rem;
  top: 0;
  right: 20%;
  z-index: 99;
  border-radius: 100%;
  background-color: #ffe600;
}
.notification-wrapper {
  position: relative;
  cursor: pointer;
}
.input-searchbar-container {
  position: relative;
  width: 100%;
}
.input-searchbar-container input {
  width: 100%;
  background-color: rgba(114, 114, 127, 0.08);
  border: 1px solid rgba(46, 46, 56, 0.08);
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  padding: 1.125rem 3.75rem 1.125rem 1rem;
}
.input-searchbar-container .input-wrapper {
  position: relative;
  z-index: 102;
}
.input-searchbar-container .input-wrapper .input-icon {
  position: absolute;
  right: 1.25rem;
  top: 50%;
  color: rgba(114, 114, 127, 0.64);
  font-size: 1.5625rem;
  line-height: 1.5625rem;
  transform: translateY(-50%);
}
.input-searchbar-container .input-wrapper .btn-cancel {
  padding: 0;
  border: 0;
}
.input-searchbar-container .searchbar-container {
  padding-bottom: 0.5rem;
  border: 0.0625rem solid rgba(46, 46, 56, 0.08);
  border-radius: 0.125rem;
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background-color: #ffffff;
  z-index: 102;
  box-shadow: 0 24px 24px 0 rgba(46, 46, 56, 0.02);
}
.input-searchbar-container .searchbar-container .category {
  font-size: 0.75rem;
  line-height: 0.875rem;
  color: #2e2e38;
  padding: 0.5rem 0;
  margin: 0.5rem 0 0.5rem 1rem;
  border-bottom: 0.0625rem solid rgba(46, 46, 56, 0.08);
  width: calc(100% - 16px);
}
.input-searchbar-container .searchbar-container .entity-container {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.25rem;
}
.input-searchbar-container .searchbar-container .entity-container .entity-name {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #72727f;
  margin: 0;
  display: flex;
  align-items: center;
}
.input-searchbar-container .searchbar-container .entity-container .entity-name .ic-fav-on {
  font-size: 0.9375rem;
  line-height: 0.9375rem;
  color: rgba(114, 114, 127, 0.32);
  margin-left: 0.3125rem;
}
.input-searchbar-container .searchbar-container .entity-container .details-info {
  font-size: 0.75rem;
  line-height: 0.875rem;
  color: rgba(114, 114, 127, 0.64);
  margin: 0;
}
.input-searchbar-container .searchbar-container .entity-container:hover,
.input-searchbar-container .searchbar-container .entity-container:focus,
.input-searchbar-container .searchbar-container .entity-container:active {
  text-decoration: none;
  background-color: rgba(114, 114, 127, 0.08);
}
.input-searchbar-container .searchbar-container .entity-container .entity-info-wrapper {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  margin-left: 1rem;
}
.input-searchbar-container .searchbar-container .entity-container .entity-info-wrapper .ic-chevron-right {
  font-size: 1rem;
  line-height: 1rem;
  color: #72727f;
}
.input-searchbar-container .searchbar-container .entity-container .container-img {
  position: relative;
}
.input-searchbar-container .searchbar-container .entity-container .container-img .chart {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 0.625rem;
  line-height: 0.625rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.56);
}
.input-searchbar-container .searchbar-container .entity-container .container-img .entity-img {
  width: 1.875rem;
  height: 1.875rem;
}
.input-searchbar-container .searchbar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100;
}
/*# sourceMappingURL=topbar.component.css.map */
